import type { ID } from '@octopus-do/octopus-project-core'
import { Plus as PlusIcon } from '@octopus-do/octopus-storybook/icons'
import { DashboardActions } from '@store/reducers/dashboard/actions'
import { getId } from '@store/utils'
import type React from 'react'
import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { clsJoin } from '@/utils'
import { FolderInput } from '../FolderInput'
import { FolderLinkCls } from '../FolderLink'
import css from './styles.module.css'

interface Props {
  workspaceId: ID
  order: number
}

export const CreateFolder: React.FC<Props> = ({ workspaceId, order }) => {
  const dispatch = useDispatch()

  const [showInput, setShowInput] = useState(false)

  const handleAddFolder = () => {
    setShowInput(true)
  }

  const handleCreateFolder = (value: string) => {
    if (!value) {
      return
    }

    dispatch(
      DashboardActions.folders.create({
        workspaceId,
        folder: {
          members: [],
          visibility: 'public',
          id: getId(),
          title: value,
          type: 'folder',
          projects: [],
          order,
        },
      })
    )
  }

  if (showInput) {
    return (
      <FolderInput
        onSubmit={(value) => {
          handleCreateFolder(value)
          setShowInput(false)
        }}
      />
    )
  }

  return (
    <button
      className={clsJoin(FolderLinkCls.wrapper, css.create_button)}
      onClick={handleAddFolder}
    >
      <div className={FolderLinkCls.icon}>
        <PlusIcon />
      </div>
      <div className={FolderLinkCls.text}>
        <div className={FolderLinkCls.title}>New folder</div>
      </div>
    </button>
  )
}
